export const Status = ['ACTIVE', 'INACTIVE'];

export const Status2 = ['RUNNING', 'PAUSED', 'STOPPED'];

export const UserType = ['ENTERPRISE', 'ADVERTISER'];

export const RoleType = ['ANALYST', 'ACCOUNT_MANAGER'];

export const Exchange = ['Applovin', 'Vungle', 'Smartyads', 'Admixer', 'Vertoz', 'Verve'];

export const CreativeType = ['BANNER', 'VIDEO', 'NATIVE', 'HTML'];

export const CappingType = ['BUDGET', 'CLICK', 'IMPRESSION'];

export const FrequencyCappingType = ['CLICK', 'IMPRESSION'];

export const OrderType = ['APP', 'WEBSITE'];

export const TrafficType = ['APP', 'WEB', 'CTV'];

export const NetworkType = ['CELLULAR', 'WIFI'];

export const PlatformType = ['ANDROID', 'IOS'];

export const FilterType = ['SPECIFIC', 'RANGE'];

export const Identifier = ['PRESENT', 'MISSING'];

export const DeviceType = ['PHONE', 'TABLET'];

export const AdFormatType = ['REWARDED', 'INTERSTITIAL'];

export const OperationType = ['OR', 'AND'];

export const CreditActivity = ['DEPOSIT', 'WITHDRAW'];

export const ActivityType = ['POST_PAYMENT', 'PRE_PAYMENT'];

export const SpendMethod = ['IMPRESSION', 'WIN', 'BURL'];

export const Region = [
  'SINGAPORE',
  'USA',
];

export const AudienceRegion = [
  { label: 'Singapore', value: 'SINGAPORE' },
  { label: 'USA', value: 'USA' },
];

export const AudienceRefreshType = [
  { label: 'One Time', value: 'ONE_TIME' },
  { label: 'Recurring', value: 'RECURRING' },
];

export const AudienceType = [
  { label: 'Normal', value: 'NORMAL' },
  { label: 'Hashed', value: 'HASHED' },
];

export const Brands = [
  'Acer',
  'Alcatel',
  'Amazon',
  'Apple',
  'Archos',
  'Asus',
  'BenQ',
  'BlackBerry',
  'Dell',
  'Essential',
  'GeeksPhone',
  'Google',
  'HP',
  'HTC',
  'Huawei',
  'Jolla',
  'Lenovo',
  'LG',
  'Meizu',
  'Microsoft',
  'Motorola',
  'Nexian',
  'Nintendo',
  'Nokia',
  'Nvidia',
  'OnePlus',
  'Ouya',
  'Palm',
  'Panasonic',
  'Pebble',
  'Polytron',
  'RIM',
  'Samsung',
  'Sharp',
  'Siemens',
  'Sony[Ericsson]',
  'Sprint',
  'Xbox',
  'Xiaomi',
  'ZTE',
];

export const AndroidVersions = [
  '1',
  '1.1',
  '1.5',
  '1.6',
  '2',
  '2.0.1',
  '2.1',
  '2.2',
  '2.2.1',
  '2.2.2',
  '2.2.3',
  '2.3',
  '2.3.1',
  '2.3.2',
  '2.3.3',
  '2.3.4',
  '2.3.5',
  '2.3.6',
  '2.3.7',
  '3',
  '3.1',
  '3.2',
  '3.2.1',
  '3.2.2',
  '3.2.3',
  '3.2.4',
  '3.2.5',
  '3.2.6',
  '4',
  '4.0.1',
  '4.0.2',
  '4.0.3',
  '4.0.4',
  '4.1',
  '4.1.2',
  '4.2',
  '4.2.1',
  '4.2.2',
  '4.3',
  '4.3.1',
  '4.4',
  '4.4.1',
  '4.4.2',
  '4.4.3',
  '4.4.4',
  '5',
  '5.0.1',
  '5.0.2',
  '5.1',
  '5.1.1',
  '6.0',
  '6.0.1',
  '7',
  '7.1',
  '7.1.1',
  '7.1.2',
  '8',
  '8.1',
  '9',
  '10',
  '11',
  '12',
  '12.1',
  '13',
  '14',
  '15',
];
export const FrequencyAudienceType = [
  'Equal to',
  'Fewer than or Equal to',
  'More than or Equal to',
];

export const Events = ['country', 'os', 'goal', 'currency', 'revenue', 'All'];

export const RevenueOperatorType = [
  'More Than',
  'More than or Equal to',
  'Fewer than or Equal to',
  'Fewer than',
  'Equal to',
];

export const TypeAfilters = ['is', 'is not'];

export const Currency = ['USD', 'IND'];
